import React from 'react';
import RangeField from 'components/form/field/range-field';
import useProvider from 'hooks/useProvider';
import { valueLabelFormatter } from '../formatters';

export default ({ providers, field, label, input, meta, disabled, labelSize, qaId }) => {
  const fields = useProvider(providers, field.provider, [], valueLabelFormatter);

  return (
    <RangeField
      label={label}
      input={input}
      meta={meta}
      disabled={disabled}
      labelSize={labelSize}
      qaId={qaId}
      fields={fields}
      minText={providers[field.rangeProvider] ? providers[field.rangeProvider].min : null}
      maxText={providers[field.rangeProvider] ? providers[field.rangeProvider].max : null}
    />
  );
};
